import { cn } from '@/utils/cn';
import React from 'react';

interface MultiselectAutoCompleteSelectedItemProps<T> {
  option: T;
  disabled?: boolean;
  getLabel: (option: T) => string;
  onRemove: () => void;
  renderSelectedItem?: (option: T, disabled: boolean, onRemove: () => void) => React.ReactNode;
}

const MultiselectAutoCompleteSelectedItem = <T,>({
  option,
  disabled = false,
  getLabel,
  onRemove,
  renderSelectedItem,
}: MultiselectAutoCompleteSelectedItemProps<T>) => {
  // RENDER
  if (renderSelectedItem) return renderSelectedItem(option, disabled, onRemove);

  return (
    <div className="flex items-center gap-[6px] border border-[#0C8DBF] bg-[#E4F8FF] px-[3px] py-[1px] rounded-[4px]">
      <span className="text-[11px] text-[#0C8DBF]">{getLabel(option)}</span>
      <div
        className={cn('hover:opacity-70 cursor-pointer', {
          'cursor-not-allowed opacity-50': disabled,
        })}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) {
            onRemove();
          }
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
          <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#0C8DBF" strokeLinecap="round" />
        </svg>
      </div>
    </div>
  );
};

export default MultiselectAutoCompleteSelectedItem;
